<div class="menu-content">
  <div class="menu-close" (click)="closeMenu()">
    <i class="fa fa-times-circle menu-close-btn"></i>
  </div>
  <div class="fade-setup" *ngIf="activeMenu == 'fade'">
    <div class="property">
      <label>Fade In(s)</label>
      <ng5-slider [(value)]="fadeIn" [options]="{floor: 0, ceil: 20, animate: false}" (userChange)="setFadeIn($event.value)"></ng5-slider>
    </div>
    <div class="property">
      <label>Fade Out(s)</label>
      <ng5-slider [(value)]="fadeOut" [options]="{floor: 0, ceil: 20, animate: false}" (userChange)="setFadeOut($event.value)"></ng5-slider>
    </div>
    <div class="property">
        <label>Opacity</label>
        <ng5-slider [(value)]="opacity" [options]="{floor: 0, ceil: 100, animate: false}" (userChange)="setOpacity($event)"></ng5-slider>
    </div>
    <div class="property" *ngIf="isImageClip()">
      <label>Resize</label>
      <div class="resize-buttons d-flex justify-content-between w-100">
        <div class="resize-button" (click)="fitToScreen()">Fill</div>
        <div class="resize-button" (click)="scaleToScreen()">Contain</div>
      </div>
    </div>
    <div class="property">
      <label>Rotate</label>
      <div class="resize-buttons d-flex justify-content-between w-100">
        <div class="resize-button" (click)="rotate(90)" [ngbTooltip]="'Rotate clockwise'" container="body"><i class="fa fa-repeat"></i></div>
        <div class="resize-button" (click)="rotate(-90)" [ngbTooltip]="'Rotate counter clockwise'" container="body"><i class="fa fa-undo"></i></div>
      </div>
    </div>
  </div>

  <div class="effect-title mt-3">Motion
    <app-toggle-switch class="toggle-switch toggle-switch-small" (onChange)="toggleKenBurns($event)" [checked]="clipComponent.clip.effects.kenBurnsStatus"></app-toggle-switch>
  </div>
  <div class="effect-settings-container" *ngIf="clipComponent.clip.effects.kenBurnsStatus">
    <div class="effect-subtitle" *ngIf="isImageClip()">Preset</div>
    <div class="ken-burns-preset-list" *ngIf="isImageClip()">
      <div class="ken-burns-open-preset" (click)="openKenBurnsPreset()">Open...</div>
    </div>
    <div class="effect-subtitle">Start Frame</div>
    <div class="scale-setup" *ngIf="activeMenu == 'fade'">
      <div class="property">
          <label>Zoom</label>
          <ng5-slider [(value)]="scaleInFactor" [options]="{floor: 1, ceil: 5, animate: false, step: 0.01}" (userChange)="setScaleInFactor($event.value)"></ng5-slider>
      </div>
    </div>
    <div class="scale-setup" *ngIf="activeMenu == 'fade'">
      <div class="property">
        <label>Position (X)</label>
        <ng5-slider [(value)]="scaleInOffsetX" [options]="{floor: -600, ceil: 600, animate: false}" (userChange)="setScaleInOffsetX($event.value)"></ng5-slider>
      </div>
      <div class="property">
        <label>Position (Y)</label>
        <ng5-slider [(value)]="scaleInOffsetY" [options]="{floor: -600, ceil: 600, animate: false}" (userChange)="setScaleInOffsetY($event.value)"></ng5-slider>
      </div>
    </div>
    <div class="effect-subtitle">End Frame</div>
    <div class="scale-offset-setup" *ngIf="activeMenu == 'fade'">
      <div class="property">
        <label>Zoom</label>
        <ng5-slider [(value)]="scaleOutFactor" [options]="{floor: 1, ceil: 5, animate: false, step: 0.01}" (userChange)="setScaleOutFactor($event.value)"></ng5-slider>
      </div>
    </div>
    <div class="scale-offset-setup" *ngIf="activeMenu == 'fade'">
      <div class="property">
        <label>Position (X)</label>
        <ng5-slider [(value)]="scaleOutOffsetX" [options]="{floor: -600, ceil: 600, animate: false}" (userChange)="setScaleOutOffsetX($event.value)"></ng5-slider>
      </div>
      <div class="property">
        <label>Position (Y)</label>
        <ng5-slider [(value)]="scaleOutOffsetY" [options]="{floor: -600, ceil: 600, animate: false}" (userChange)="setScaleOutOffsetY($event.value)"></ng5-slider>
      </div>
    </div>
  </div>
  <div class="effect-title" *ngIf="clipComponent.clip.transcription">Unlock <i class="fa fa-info-circle text-primary" [ngbTooltip]="'You can change subtitle position individually or all at the same time.'"></i>
    <app-toggle-switch class="toggle-switch toggle-switch-small" (onChange)="toggleUnlock($event)" [checked]="clipComponent.clip.unlocked"></app-toggle-switch>
  </div>
  <div class="delete" *ngIf="activeMenu == 'delete'">
    <div class="prompt-popover">
      <div class="prompt-title">Are you sure?</div>
      <button class="yes" (click)="popoverYes()">Yes</button><button class="no" (click)="popoverNo()">No</button>
    </div>
  </div>
  <div class="fillcolor" *ngIf="activeMenu == 'fillcolor'">
    <div class="prompt-popover">
      <div class="tool wave-color"
           [(colorPicker)]="clipComponent.clip.color"
           [cpDialogDisplay]="'inline'"
           [cpToggle]="true"
      ></div>
    </div>
  </div>
</div>
<ul class="row menu-tabs clearfix">
  <li class="col-md-3 fade-tab" [ngClass]="{'active' : activeMenu == 'fade'}" (click)="setActive('fade')"></li>
  <li class="col-md-3" (click)="duplicate()" *ngIf="clipComponent.clip.type != 'speechindicator'"><i class="fa fa-copy"></i></li>
  <li class="col-md-3" (click)="edit()" *ngIf="clipComponent.clip.type != 'speechindicator' && clipComponent.clip.type != 'audiogram'"><i class="fa fa-pencil"></i></li>
  <li class="col-md-3" [ngClass]="{'active' : activeMenu == 'fillcolor'}" (click)="setActive('fillcolor')" *ngIf="clipComponent.clip.type == 'audiogram'"><i class="fa fa-eyedropper"></i></li>
  <li class="col-md-3" [ngClass]="{'active' : activeMenu == 'delete'}" (click)="setActive('delete')"><i class="fa fa-trash"></i></li>
</ul>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/video-layer/clip/clip-menu/clip-menu.component.html